import React from 'react';
import { Info } from 'lucide-react';
import { SectionCard } from '../../common';

/** "Detalle de Cálculo SOS" for a single selected store. */
export default function SOSCalculationDetail({ store }) {
    return (
        <SectionCard icon={<Info />} iconTone="info" title="Detalle de Cálculo SOS" description="Fórmula: (Caras de la categoría / Total de caras) × 100">
            <div className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-info-border bg-info-bg px-4 py-3 text-sm text-info-fg">
                <span className="font-medium">
                    Total de caras en esta tienda: <span className="tabular-nums font-semibold">{store.totalFaces}</span>
                </span>
            </div>

            <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
                {store.categories.map((cat) => (
                    <div key={cat.category} className="rounded-lg border border-surface-200 p-3">
                        <div className="mb-1 text-sm font-medium text-surface-900">{cat.category}</div>
                        <div className="text-sm text-surface-500 tabular-nums">
                            {cat.faces} caras ÷ {store.totalFaces} = <strong className="font-semibold text-surface-900">{cat.actualPercentage.toFixed(2)}%</strong>
                        </div>
                    </div>
                ))}
            </div>
        </SectionCard>
    );
}
